import { useTheme } from "@emotion/react";
import {
  Cancel,
  CheckCircle,
  ExpandMore,
  LabelOutlined,
} from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Button,
  CircularProgress,
  Collapse,
  FormControlLabel,
  FormGroup,
  Paper,
  Snackbar,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { alpha, Box } from "@mui/system";
import { useEffect, useState } from "react";
import api from "../../../../../../services/api";
import useStyles from "./styles";

export default function ConfigReferenciaServico() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const erp = window?.config?.REACT_APP_ERP || process.env.REACT_APP_ERP;
  const [configClienteGlobal, setConfigClienteGlobal] = useState({
    serviceReferencia: {
      isRefService: false,
      regex: "",
      invert: false,
    },
  });

  const [changeConfig, setChangeConfig] = useState("");
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editRegexRef, setEditRegexRef] = useState(false);
  const [editRegexRefInterno, setEditRegexRefInterno] = useState(false);
  const [snackbar, setSnackbar] = useState(null);

  const configErp = () => {
    switch (erp) {
      case "HUBSOFT":
        return {
          ref: "referência",
          serv: "serviço",
          labelRef: `Mostrar 'Referência' do Serviço para os CLIENTES.`,
          labelRefInterno: `Mostrar 'Referência' do Serviço para os USUÁRIOS INTERNO.`,
          descriptionRef:
            "Quando ativado, os serviços do cliente serão exibidos com a referência cadastrada no Hubsoft.",
          infoRegex:
            "Caso necessário, adicione uma expressão regular para identificar a referência do serviço.",
          infoInvert:
            "Quando ativado, a refrência será exibida primeiro, seguida do nome do serviço.",
        };
        break;
      case "IXC":
        return {
          ref: "descrição auxiliar",
          serv: "contrato",
          labelRef: `Mostrar 'Descrição auxiliar' do Contrato para os CLIENTES.`,
          labelRefInterno: `Mostrar 'Descrição auxiliar' do Contrato para USUÁRIOS INTERNO.`,
          descriptionRef:
            "Quando ativado, os contratos do cliente serão exibidos com a descrição auxiliar cadastrada no IXC.",
          infoRegex:
            "Caso necessário, adicione uma expressão regular para identificar a descrição auxiliar do contrato.",
          infoInvert:
            "Quando ativado, a descrição auxiliar será exibida primeiro, seguida do nome do contrato.",
        };
        break;
    }
  };

  useEffect(() => {
    getConfig();
  }, []);

  const getConfig = async () => {
    setLoading(true);
    try {
      const response = await api.get("/interno/find/configClientes");

      setConfigClienteGlobal(response?.data?.configGlobal);
      setChangeConfig(response?.data?.configGlobal?.config);
    } catch (error) {
      console.error("Erro ao buscar configuração:", error);
      setSnackbar({
        children: "Erro ao buscar configuração!",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const updateConfigGlobal = async (
    id,
    openTicket,
    config,
    type,
    sendMessage = undefined,
  ) => {
    //type 0 = interno, 1 = cliente,
    setLoadingUpdate(true);

    try {
      const response = await api.post("/interno/update/configClienteGlobal", {
        idConfigGlobal: id,
        openTicket: openTicket,
        config: config || null,
        sendMessage: sendMessage,
      });
      setConfigClienteGlobal((prev) => {
        return {
          ...prev,
          openTicket:
            response?.data?.openTicket !== undefined
              ? response?.data?.openTicket
              : prev?.openTicket,
          sendMessage:
            response?.data?.sendMessage !== undefined
              ? response?.data?.sendMessage
              : prev?.sendMessage,
          config:
            response?.data?.config !== undefined
              ? response?.data?.config
              : prev?.config,
        };
      });

      if (type === 0) {
        setChangeConfig((prev) => {
          return {
            ...prev,
            serviceReferenciaInterno:
              response?.data?.config?.serviceReferenciaInterno,
          };
        });
      } else if (type === 1) {
        setChangeConfig((prev) => {
          return {
            ...prev,
            serviceReferencia: response?.data?.config?.serviceReferencia,
          };
        });
      }

      setSnackbar({
        children: "Configuração global de cliente atualizada com sucesso!",
        severity: "success",
      });
    } catch (error) {
      console.error("Erro ao atualizar configuração:", error);
      setSnackbar({
        children: "Erro ao atualizar configuração global!",
        severity: "error",
      });
    } finally {
      if (type === 0) {
        setEditRegexRefInterno(false);
      }
      if (type === 1) {
        setEditRegexRef(false);
      }

      setLoadingUpdate(false);
    }
  };

  const handleEditRegex = () => {
    setEditRegexRef(true);
  };
  const handleEditRegexInterno = () => {
    setEditRegexRefInterno(true);
  };
  const handleCancel = () => {
    setEditRegexRef(false);

    setConfigClienteGlobal((prev) => ({
      ...prev,
      config: {
        ...prev.config,
        serviceReferencia: changeConfig.serviceReferencia,
      },
    }));
  };
  const handleCancelInterno = () => {
    setEditRegexRefInterno(false);
    setConfigClienteGlobal((prev) => ({
      ...prev,
      config: {
        ...prev.config,
        serviceReferenciaInterno: changeConfig.serviceReferenciaInterno,
      },
    }));
  };

  return (
    <>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Box sx={styles.containerHeader}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <LabelOutlined color="primary" />
              <Typography
                variant="h5"
                sx={{
                  ...styles.title,
                }}
              >
                Configuração de {configErp()?.ref} do {configErp()?.serv}
              </Typography>
            </Box>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Paper variant="outlined" sx={styles.paperBody}>
            {loading ? (
              <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
                <CircularProgress />
              </Box>
            ) : (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                {(erp === "HUBSOFT" || erp === "IXC") && (
                  <Paper variant="outlined" sx={styles.paperContainer}>
                    <Box sx={styles.boxContainer}>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Switch
                                disabled={loadingUpdate}
                                sx={styles.switch}
                                checked={
                                  configClienteGlobal?.config?.serviceReferencia
                                    ?.isRefService
                                }
                                onChange={(e) => {
                                  setConfigClienteGlobal((prev) => ({
                                    ...prev,
                                    config: {
                                      ...prev?.config,
                                      serviceReferencia: {
                                        ...(prev?.config?.serviceReferencia ||
                                          {}),
                                        isRefService: e.target.checked,
                                      },
                                    },
                                  }));

                                  updateConfigGlobal(
                                    configClienteGlobal?.id,
                                    null,
                                    {
                                      ...configClienteGlobal?.config, // Mantém as outras configurações (ex: cores, notificações)
                                      serviceReferencia: {
                                        ...configClienteGlobal?.config
                                          ?.serviceReferencia, // Mantém o que já tinha no serviceReferencia
                                        isRefService: e.target.checked, // Altera o que você quer
                                      },
                                    },
                                    1,
                                  );
                                }}
                                checkedIcon={<CheckCircle sx={styles.icon} />}
                                icon={<Cancel sx={styles.icon} />}
                                focusVisibleClassName=".Mui-focusVisible"
                                disableRipple
                              />
                            }
                            sx={{ margin: 0 }}
                          />
                        </FormGroup>

                        <Box>
                          <Typography variant="body2" sx={styles.titleSwitch}>
                            {configErp()?.labelRef}
                          </Typography>
                          <Typography sx={styles.subtitle}>
                            {configErp()?.descriptionRef}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                    <Collapse
                      in={
                        configClienteGlobal?.config?.serviceReferencia
                          ?.isRefService
                      }
                    >
                      {" "}
                      <Paper
                        variant="outlined"
                        elevation={3}
                        sx={styles.paperDatagrid}
                      >
                        <Box sx={styles.boxEdit}>
                          {/* LINHA 1: REGEX */}
                          <Box sx={styles.BoxInfo}>
                            <TextField
                              variant="filled"
                              disabled={!editRegexRef}
                              value={
                                configClienteGlobal?.config?.serviceReferencia
                                  ?.regex || ""
                              }
                              autoComplete="off"
                              size="small"
                              label={`Regex para ${configErp()?.ref}`}
                              sx={styles.textField}
                              onChange={(e) => {
                                setConfigClienteGlobal((prev) => ({
                                  ...prev,
                                  config: {
                                    ...prev?.config,
                                    serviceReferencia: {
                                      ...(prev?.config?.serviceReferencia ||
                                        {}),
                                      regex: e.target.value,
                                    },
                                  },
                                }));
                              }}
                            />
                            <Paper variant="outlined" sx={styles.paperInfo}>
                              <Typography sx={styles.textInfo}>
                                {configErp()?.infoRegex}
                              </Typography>
                            </Paper>
                          </Box>

                          {/* LINHA 2: SWITCH DE INVERSÃO */}
                          <Box sx={styles.BoxInfo}>
                            <Box
                              sx={{
                                flex: { xs: "1 1 auto", md: "0 0 400px" },
                                display: "flex",
                                alignItems: "center",
                                backgroundColor: editRegexRef
                                  ? theme.palette.mode === "dark"
                                    ? "action.hover"
                                    : theme.palette.action.hover
                                  : theme.palette.mode === "dark"
                                    ? alpha(theme.palette.action.hover, 0.1)
                                    : theme.palette.colors.black.lighter,
                                borderRadius: "8px",
                                p: 0.5,
                                height: "48px", // Mesma altura do TextField para alinhar visualmente
                              }}
                            >
                              <FormControlLabel
                                disabled={!editRegexRef}
                                sx={{ ml: 1, width: "100%" }}
                                control={
                                  <Switch
                                    disabled={!editRegexRef}
                                    checked={
                                      !!configClienteGlobal?.config
                                        ?.serviceReferencia?.invert
                                    }
                                    onChange={(e) => {
                                      setConfigClienteGlobal((prev) => ({
                                        ...prev,
                                        config: {
                                          ...prev?.config,
                                          serviceReferencia: {
                                            ...(prev?.config
                                              ?.serviceReferencia || {}),
                                            invert: e.target.checked,
                                          },
                                        },
                                      }));
                                    }}
                                  />
                                }
                                label={
                                  <Typography
                                    sx={{
                                      fontSize: "14px",
                                      fontWeight: 500,
                                      color: editRegexRef
                                        ? "text.primary"
                                        : "text.disabled",
                                    }}
                                  >
                                    Inverter informações
                                  </Typography>
                                }
                              />
                            </Box>

                            <Paper variant="outlined" sx={styles.paperInfo}>
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  color: "text.secondary",
                                  lineHeight: 1.4,
                                }}
                              >
                                {configErp()?.infoInvert}
                              </Typography>
                            </Paper>
                          </Box>
                        </Box>

                        {/* BOTÕES DE AÇÃO */}
                        <Box sx={styles.containerActions}>
                          {editRegexRef ? (
                            <Box sx={{ display: "flex", gap: 1 }}>
                              <Button
                                disabled={loadingUpdate}
                                size="small"
                                variant="outlined"
                                onClick={handleCancel}
                              >
                                Cancelar
                              </Button>
                              <Button
                                onClick={() =>
                                  updateConfigGlobal(
                                    configClienteGlobal?.id,
                                    null,
                                    configClienteGlobal?.config,
                                    1,
                                  )
                                }
                                disabled={loadingUpdate}
                                size="small"
                                variant="contained"
                              >
                                Salvar
                              </Button>
                            </Box>
                          ) : (
                            <Button
                              onClick={handleEditRegex}
                              variant="contained"
                              size="small"
                              disabled={loadingUpdate}
                            >
                              Editar
                            </Button>
                          )}
                        </Box>
                      </Paper>
                    </Collapse>
                  </Paper>
                )}
                {(erp === "HUBSOFT" || erp === "IXC") && (
                  <Paper variant="outlined" sx={styles.paperContainer}>
                    <Box sx={styles.boxContainer}>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Switch
                                disabled={loadingUpdate}
                                sx={styles.switch}
                                checked={
                                  configClienteGlobal?.config
                                    ?.serviceReferenciaInterno?.isRefService
                                }
                                onChange={(e) => {
                                  setConfigClienteGlobal((prev) => ({
                                    ...prev,
                                    config: {
                                      ...prev?.config,
                                      serviceReferenciaInterno: {
                                        ...(prev?.config
                                          ?.serviceReferenciaInterno || {}),
                                        isRefService: e.target.checked,
                                      },
                                    },
                                  }));

                                  updateConfigGlobal(
                                    configClienteGlobal?.id,
                                    null,
                                    {
                                      ...configClienteGlobal?.config, // Mantém as outras configurações (ex: cores, notificações)
                                      serviceReferenciaInterno: {
                                        ...configClienteGlobal?.config
                                          ?.serviceReferenciaInterno, // Mantém o que já tinha no serviceReferencia
                                        isRefService: e.target.checked, // Altera o que você quer
                                      },
                                    },
                                  );
                                }}
                                checkedIcon={<CheckCircle sx={styles.icon} />}
                                icon={<Cancel sx={styles.icon} />}
                                focusVisibleClassName=".Mui-focusVisible"
                                disableRipple
                              />
                            }
                            sx={{ margin: 0 }}
                          />
                        </FormGroup>

                        <Box>
                          <Typography variant="body2" sx={styles.titleSwitch}>
                            {configErp()?.labelRefInterno}
                          </Typography>
                          <Typography sx={styles.subtitle}>
                            {configErp()?.descriptionRef}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                    <Collapse
                      in={
                        configClienteGlobal?.config?.serviceReferenciaInterno
                          ?.isRefService
                      }
                    >
                      {" "}
                      <Paper
                        variant="outlined"
                        elevation={3}
                        sx={styles.paperDatagrid}
                      >
                        <Box sx={styles.boxEdit}>
                          <Box sx={styles.BoxInfo}>
                            <TextField
                              variant="filled"
                              disabled={!editRegexRefInterno}
                              value={
                                configClienteGlobal?.config
                                  ?.serviceReferenciaInterno?.regex || ""
                              }
                              autoComplete="off"
                              size="small"
                              label={`Regex para ${configErp()?.ref}`}
                              placeholder=""
                              sx={styles.textField}
                              onChange={(e) => {
                                setConfigClienteGlobal((prev) => ({
                                  ...prev,
                                  config: {
                                    ...prev?.config,
                                    serviceReferenciaInterno: {
                                      ...(prev?.config
                                        ?.serviceReferenciaInterno || {}),
                                      regex: e.target.value,
                                    },
                                  },
                                }));
                              }}
                            />
                            <Paper sx={styles.paperInfo} variant="outlined">
                              <Typography sx={styles.textInfo}>
                                {configErp()?.infoRegex}
                              </Typography>
                            </Paper>
                          </Box>

                          <Box sx={styles.BoxInfo}>
                            <Box
                              sx={{
                                flex: { xs: "1 1 auto", md: "0 0 400px" },
                                display: "flex",
                                alignItems: "center",
                                backgroundColor: editRegexRef
                                  ? theme.palette.mode === "dark"
                                    ? "action.hover"
                                    : theme.palette.action.hover
                                  : theme.palette.mode === "dark"
                                    ? alpha(theme.palette.action.hover, 0.1)
                                    : theme.palette.colors.black.lighter,
                                borderRadius: "8px",
                                p: 0.5,
                                height: "48px", // Mesma altura do TextField para alinhar visualmente
                              }}
                            >
                              <FormControlLabel
                                disabled={!editRegexRefInterno}
                                sx={{ ml: 1, width: "100%" }}
                                control={
                                  <Switch
                                    disabled={!editRegexRefInterno}
                                    checked={
                                      !!configClienteGlobal?.config
                                        ?.serviceReferenciaInterno?.invert
                                    }
                                    onChange={(e) => {
                                      setConfigClienteGlobal((prev) => ({
                                        ...prev,
                                        config: {
                                          ...prev?.config,
                                          serviceReferenciaInterno: {
                                            ...(prev?.config
                                              ?.serviceReferenciaInterno || {}),
                                            invert: e.target.checked,
                                          },
                                        },
                                      }));
                                    }}
                                  />
                                }
                                label={
                                  <Typography
                                    sx={{
                                      fontSize: "14px",
                                      fontWeight: 500,
                                      color: editRegexRef
                                        ? "text.primary"
                                        : "text.disabled",
                                    }}
                                  >
                                    Inverter informações
                                  </Typography>
                                }
                              />
                            </Box>

                            <Paper variant="outlined" sx={styles.paperInfo}>
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  color: "text.secondary",
                                  lineHeight: 1.4,
                                }}
                              >
                                {configErp()?.infoInvert}
                              </Typography>
                            </Paper>
                          </Box>
                        </Box>
                        <Box sx={styles.containerActions}>
                          {editRegexRefInterno ? (
                            <Box sx={{ display: "flex", gap: 1 }}>
                              <Button
                                disabled={loadingUpdate}
                                size="small"
                                variant="outlined"
                                onClick={handleCancelInterno}
                              >
                                Cancelar
                              </Button>
                              <Button
                                onClick={() =>
                                  updateConfigGlobal(
                                    configClienteGlobal?.id,
                                    null,
                                    configClienteGlobal?.config,
                                    0,
                                  )
                                }
                                disabled={loadingUpdate}
                                size="small"
                                variant="contained"
                              >
                                Salvar
                              </Button>
                            </Box>
                          ) : (
                            <Button
                              onClick={handleEditRegexInterno}
                              variant="contained"
                              size="small"
                              disabled={loadingUpdate}
                            >
                              Editar
                            </Button>
                          )}
                        </Box>
                      </Paper>
                    </Collapse>
                  </Paper>
                )}
              </Box>
            )}
          </Paper>
        </AccordionDetails>
      </Accordion>
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
    </>
  );
}
